import Activity from "../components/slides/Activity";
import StoryElements from "../components/slides/StoryElements";

export const slidesDeck = [
  {
    path: "/elements-of-story-writing",
    element: <StoryElements />,
  },
  {
    path: "/definition-of-setting",
    element: <Activity />,
  },
];
